module.exports = __webpack_public_path__ + "media/img/frontend_application/coupon-blue-38ed1ce882df345afe529774583ed4df.png";